import { useEffect } from "react";
import { LandingFooter, LandingHeader } from "@/components/landing/LandingChrome";
import { Hero } from "@/components/landing/Hero";
import { Audience, Entreprises, Particuliers, Steps } from "@/components/landing/Sections";
import { Simulator } from "@/components/landing/Simulator";
import { ComingSoon, Faq, FinalCta, Security } from "@/components/landing/MoreSections";

export default function Landing() {
  useEffect(() => { document.title = "CASHMY — Le copilote financier du foyer et de l'entreprise"; }, []);
  return (
    <div className="min-h-screen scroll-smooth bg-background" data-testid="landing-page">
      <LandingHeader />
      <main>
        <Hero />
        <Audience />
        <Particuliers />
        <Simulator />
        <Entreprises />
        <Security />
        <Steps />
        <Faq />
        <ComingSoon />
        <FinalCta />
      </main>
      <LandingFooter />
    </div>
  );
}
